import React, { useState, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import * as Yup from 'yup';

import { parseDateString, t } from '~/helpers';
import { Report } from '~/components';
import { DateTime, Autocomplete, RadioGroup } from '~/components/Form';
import { GFE, GFO } from '~/constants/perfil';

export default function Relabastecimentonoperiododata() {
  const [open, setOpen] = useState(true);
  const [organ, setOrgan] = useState({ orga_codigo: '', orga_nome: '' });
  const [product, setProduct] = useState({
    prod_codigo: '',
    prod_descricao: '',
  });

  const { glousuariotipo, glousuarioorgacodigo } = useSelector(
    (state) => state.user.profile
  );

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const title = useMemo(
    () =>
      glousuariotipo === GFE
        ? 'Consumo De Combustível Do Estado No Período – Data'
        : 'Consumo De Combustível Do Órgão No Período – Data',
    [glousuariotipo, GFE]
  );

  const handleCloseReport = useCallback(() => {
    setOpen(false);
  }, []);

  const handleValidate = useCallback(
    async (data) => {
      try {
        const schema = Yup.object().shape({
          datahorainicial: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
          datahorafinal: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(datahorafinal, `Não pode ser superior à ${datahorafinal}`)
            .min(
              Yup.ref('datahorainicial'),
              'Não pode ser inferior à data inicial'
            ),
        });

        await schema.validate(data, { abortEarly: false });
      } catch (err) {
        const form = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            form[error.path] = error.message.replace(`${error.path} `, '');
          });

          throw { form };
        } else {
          throw err;
        }
      }
    },
    [datahorafinal]
  );

  const onSerializeData = useCallback(
    (data) => ({
      ...data,
      orgao: organ.orga_codigo,
      orgaonome: organ.orga_nome,
      produto: product.prod_codigo,
      produtostr: product.prod_descricao,
    }),
    [organ, product]
  );

  return (
    <Report
      open={open}
      title={title}
      onClose={handleCloseReport}
      validate={handleValidate}
      serialize={onSerializeData}
      relatorio="consumocombustivelorgaoperiododata"
      initials={{
        datahorainicial,
        datahorafinal,
        tipo: 'pdf',
        orgao: glousuarioorgacodigo,
      }}
    >
      <DateTime
        time
        disableFuture
        label="Data Inicial"
        name="datahorainicial"
      />

      <DateTime
        time
        disableFuture
        label="Data Final"
        name="datahorafinal"
        maxDateMessage=""
      />

      <Autocomplete
        name="orgao"
        label="orga_nome"
        title="Órgão"
        url="orgaos"
        unique="orga_codigo"
        getValue={(value) => setOrgan(value)}
        disabled={glousuariotipo === GFO}
      />

      <Autocomplete
        name="produto"
        label="prod_descricao"
        title="Produto"
        url="produtos"
        unique="prod_codigo"
        getValue={(value) => setProduct(value)}
      />

      <RadioGroup
        row
        name="tipo"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
      />
    </Report>
  );
}
